import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import ProgramEditSuccessPage from '@/features/programs/program-edit-success/ProgramEditSuccessPage';

export const programEditSuccessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/programas/$programId/editar/sucesso',
  component: ProgramEditSuccessPage,
});
